export const lightTheme = "lightTheme";
export const darkTheme = "darkTheme";
